import moment from "moment";
import create from "zustand";

type TimeTravelState = {
  date: string; // YYYY-MM-DD
  timestamp: number | undefined;
  setDate: (date: string) => void;
};

const useTimeTravel = create<TimeTravelState>((set) => ({
  date: "", // This is the date for which the map is rendered and transmit scale is computed
  timestamp: undefined,
  setDate: (date) =>
    set({
      date,
      timestamp: date ? moment(date).utc().unix() : undefined
    })
}));

export default useTimeTravel;
